module.exports = __webpack_public_path__ + "img/docs_upload_icon.d80b063d.svg";